import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Zoom from 'react-reveal/Zoom'

import { Grid } from '@material-ui/core'
import { Card, SectionContainer, SectionTitle, CTA } from '../../_common'

import { lightTheme } from '../../../App.theme'
import useStyles from './styles'

const getBlog = graphql`
  query {
    blog: allContentfulBlog(filter: { principal: { eq: true } }) {
      edges {
        node {
          id
          titulo
          slug
          autor
          fechaDeCreacion(formatString: "DD.MM.YY")
          imagen {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`

const Blog = () => {
  const { bRoot } = useStyles()
  const response = useStaticQuery(getBlog)
  const blog = response.blog.edges

  return (
    <SectionContainer
      sectionID="blog"
      backgroundColor={lightTheme.palette.background.extraLightOverlay}
    >
      <SectionTitle title="Blog Actuarial" />
      <Grid container className={bRoot}>
        {blog.map(({ node }) => (
          <Zoom key={node.id}>
            <Card
              data={{
                titulo: node.titulo,
                slug: node.slug,
                fecha: node.fechaDeCreacion,
                info: node.autor,
                imagen: node.imagen,
                tipo: 'blog',
              }}
              textoBoton="leer más"
            />
          </Zoom>
        ))}
      </Grid>
      <CTA linkText="Ver todo" linkRoute="/blog" />
    </SectionContainer>
  )
}

export default Blog
